module.exports = __webpack_public_path__ + "img/aa.a82470a5.jpg";